import React from "react";
import {
  MultipleUsersOutlined,
  PostThreeOutlined,
  StudentOutlined,
} from "@toddle-edu/ds-icons";

export const TRANSCRIPT_ROUTES = {
  BASE_ROUTE: "transcripts-v3",
  TEMPLATE: "template",
  STUDENTS: "students",
  SCHOOLS: "schools",
  YEAR_GROUPS: "year-groups",
};

export const SIDEBAR_NODE_IDS = {
  TEMPLATE: "TEMPLATE",
  STUDENT_TRANSCRIPTS: "STUDENT_TRANSCRIPTS",
  BY_SCHOOLS: "BY_SCHOOLS",
  BY_STUDENTS: "BY_STUDENTS",
  BY_YEAR_GROUPS: "BY_YEAR_GROUPS",
};

export const SIDEBAR_NODE_ID_TO_ROUTE_PATH_MAP = {
  [SIDEBAR_NODE_IDS.TEMPLATE]: TRANSCRIPT_ROUTES.TEMPLATE,
  [SIDEBAR_NODE_IDS.BY_SCHOOLS]: TRANSCRIPT_ROUTES.SCHOOLS,
  [SIDEBAR_NODE_IDS.BY_STUDENTS]: TRANSCRIPT_ROUTES.STUDENTS,
  [SIDEBAR_NODE_IDS.BY_YEAR_GROUPS]: TRANSCRIPT_ROUTES.YEAR_GROUPS,
};

export const QUERY_PARAMS_TO_PRESERVE = [
  "schoolIds",
  "yearGroupIds",
  "archivalState",
  "searchText",
  "orderBy",
  "orderByDirection",
  "schoolIdsEquality",
  "yearGroupIdsEquality",
  "archivalStateEquality",
];

export const QUERY_PARAM_KEYS = {
  SCHOOL_IDS: "schoolIds",
  YEAR_GROUP_IDS: "yearGroupIds",
  SCHOOL_IDS_EQUALITY: "schoolIdsEquality",
  YEAR_GROUP_IDS_EQUALITY: "yearGroupIdsEquality",
  ARCHIVAL_STATE: "archivalState",
  ARCHIVAL_STATE_EQUALITY: "archivalStateEquality",
  SEARCH_TEXT: "searchText",
  ORDER_BY: "orderBy",
  ORDER_BY_DIRECTION: "orderByDirection",
};

/** @typedef {import("@toddle-edu/ds-web").SideNavigationOptionInterface} SideNavOption */
/**
 * @param {(key: string) => string} t
 * @returns {SideNavOption[]}
 */
export const SIDEBAR_OPTIONS = (t, isSchoolPortalRoute) => [
  {
    key: "root",
    children: [
      SIDEBAR_NODE_IDS.BY_STUDENTS,
      isSchoolPortalRoute
        ? SIDEBAR_NODE_IDS.BY_YEAR_GROUPS
        : SIDEBAR_NODE_IDS.BY_SCHOOLS,
      "divider-1",
      SIDEBAR_NODE_IDS.TEMPLATE,
    ],
  },
  {
    key: SIDEBAR_NODE_IDS.BY_STUDENTS,
    title: t("common:view_by_with_label", {
      label: t("common:student_other"),
    }),
    prefix: <StudentOutlined />,
    parent: "root",
  },
  {
    key: isSchoolPortalRoute
      ? SIDEBAR_NODE_IDS.BY_YEAR_GROUPS
      : SIDEBAR_NODE_IDS.BY_SCHOOLS,
    title: t("common:view_by_with_label", {
      label: t("common:year_group"),
    }),
    prefix: <MultipleUsersOutlined />,
    parent: "root",
  },
  {
    key: "divider-1",
    isDivider: true,
  },
  {
    key: SIDEBAR_NODE_IDS.TEMPLATE,
    title: t("common:manage_with_label", {
      label: t("common:template_plural"),
    }),
    prefix: <PostThreeOutlined />,
    parent: "root",
  },
];

export const STUDENT_FEED_COLUMN_IDS = {
  STUDENT_NAME: "STUDENT_NAME",
  SCHOOL: "SCHOOL",
  YEAR_GROUP: "YEAR_GROUP",
  GRADE_LEVELS: "GRADE_LEVELS",
  LAST_UPDATED_BY: "LAST_UPDATED_BY",
  LAST_GENERATED: "LAST_GENERATED",
  DOWNLOAD: "DOWNLOAD",
};

export const FILTER_TYPES = {
  SCHOOLS: "schoolIds",
  YEAR_GROUPS: "yearGroupIds",
};

export const EQUALITY_TYPES = {
  IS: "is/are",
  IS_NOT: "is/are not",
};

export const NETWORK_STATUS = {
  LOADING: 1,
  SET_VARIABLES: 2,
  FETCH_MORE: 3,
  REFETCH: 4,
  POLL: 6,
  READY: 7,
  ERROR: 8,
};

export const DEFAULT_FILTER_VALUES = {
  ORDER_BY: "FULL_NAME",
  ORDER_BY_DIRECTION: "ASC",
  ARCHIVAL_STATE: "ALL",
  SEARCH_TEXT: "",
};
